/**
 * 认证相关 API 响应的 Zod 运行时校验 Schema
 *
 * 校验范围：登录响应、Token 刷新响应
 * 用途：在 API 边界捕获后端返回结构变化，避免静默通过导致前端异常
 */
import { z } from 'zod'

/**
 * 用户基础信息 Schema
 * 对应 src/types/user.ts 的 User 接口
 */
export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  username: z.string().optional(),
  email: z.string(),
  avatar: z.string().nullable().optional(),
  role: z.string().optional(),
  roles: z.array(z.string()).optional(),
  permissions: z.array(z.string()).optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  projectId: z.string().optional(),
  tenantId: z.string().optional(),
})

export type UserFromSchema = z.infer<typeof UserSchema>

/**
 * 登录响应 Schema
 * 对应 src/types/user.ts 的 LoginResponse 接口
 */
export const LoginResponseSchema = z.object({
  token: z.string(),
  refreshToken: z.string(),
  user: UserSchema,
  expiresIn: z.number(),
})

export type LoginResponseFromSchema = z.infer<typeof LoginResponseSchema>

/**
 * Token 刷新响应 Schema
 * 对应 src/api/auth-refresh.ts 的 RefreshResponse 接口
 */
export const RefreshResponseSchema = z.object({
  token: z.string(),
  expiresIn: z.number(),
  refreshToken: z.string().nullable().optional(),
})

export type RefreshResponseFromSchema = z.infer<typeof RefreshResponseSchema>
